/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_AccessInputs */

const en_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right of access`)
};

const de_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auskunftsrecht`)
};

const fr_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droit d'accès`)
};

const es_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derecho de acceso`)
};

const it_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diritto di accesso`)
};

const nl_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recht van inzage`)
};

const pl_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawo dostępu`)
};

const fi_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oikeus saada pääsy tietoihin`)
};

const da_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ret til indsigt`)
};

const sv_privacy_rights_item_access = /** @type {(inputs: Privacy_Rights_Item_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rätt till tillgång`)
};

/**
* | output |
* | --- |
* | "Right of access" |
*
* @param {Privacy_Rights_Item_AccessInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_access = /** @type {((inputs?: Privacy_Rights_Item_AccessInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_AccessInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_access(inputs)
	if (locale === "fr") return fr_privacy_rights_item_access(inputs)
	if (locale === "es") return es_privacy_rights_item_access(inputs)
	if (locale === "it") return it_privacy_rights_item_access(inputs)
	if (locale === "nl") return nl_privacy_rights_item_access(inputs)
	if (locale === "pl") return pl_privacy_rights_item_access(inputs)
	if (locale === "fi") return fi_privacy_rights_item_access(inputs)
	if (locale === "da") return da_privacy_rights_item_access(inputs)
	if (locale === "sv") return sv_privacy_rights_item_access(inputs)
	return en_privacy_rights_item_access(inputs)
});